module.exports = __webpack_public_path__ + "img/cargo_stopped.096634ff.svg";